'use strict';

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

module.exports = function randomHexColor() {
  return '#' + ('000000' + Math.floor(Math.random() * 16777215).toString(16)).slice(-6);
};